




























































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import EventHero from '@ui/Event/EventHero'
import TagBar from '@ui/TagBar'
import EditorContent from '@components/EditorContent'

settings =
  name: 'VendorListingDetail'

  vue:
    props: ['item', 'actions']

    components: {
      LoadingIndicator,
      EventHero,
      TagBar,
      EditorContent,
    }

    computed:
      formattedAddress: ->
        @compact([@item.city, @item.state]).join(', ')

      tagOptionsForListingTypes: ->
        {
          bar: {
            theme: 'secondary',
            max: 12,
          },
          tag: {
            theme: 'secondary',
            format: 'formatListingType',
            maxLength: 12,
          }
        }

    methods:
      hiClose: ->
        if @actions?.close?
          @actions.close()
        else 
          @$router.push(@$route.path.split('/listings/')[0])

export default VueOptions.vue settings
